import {useRepositoryContext} from "@web-libs/core/repositories/application/repository-context";
import {RepositoryRegistryEntries} from "@web-libs/core/repositories/application/repository-registry";

export const useRepositories = () => {
    const repositoryRegistry = useRepositoryContext();

    function registerRepo<K extends keyof RepositoryRegistryEntries>(key: K, repository: RepositoryRegistryEntries[K]) {
        repositoryRegistry.register(key, repository);
    }

    function getRepo<K extends keyof RepositoryRegistryEntries>(key: K): RepositoryRegistryEntries[K] {
        return repositoryRegistry.get(key);
    }

    return {
        getRepo: getRepo,
        registerRepo: registerRepo
    }
}
